/** vendor */
import React, { useState } from 'react'
import Loading from '../UI/Loading'

/** components */
import RecipeListItem from '../Recipes/RecipeListItem'
import AllergenDialog from '../Dialogs/AllergenDialog'

export default function HomeRecipesTab({ recipes }) {
    
    const [allergenDialogContent, setAllergenDialogContent] = useState([])
    const [showAllergens, setShowAllergens] = useState(false)
    const toggleAllergens = e => { setShowAllergens(!showAllergens) }

    const handleOnOpenAllergenDialog = (allergens) => {
        setAllergenDialogContent(allergens)
        setShowAllergens(true)
    }

    return (
        <div className="items-center w-full mx-auto">
            <section className="antialiased text-an_green-dark">
                <div className="flex flex-col justify-center pt-4">
                    <div>
                        { 
                            recipes &&
                                recipes.map((r) =>
                                    <div className="w-full pt-2 px-2 cursor-pointer odd:bg-an_white-dark hover:bg-an_white-darker1"> 
                                        <RecipeListItem 
                                            handleOnOpenAllergenDialog={handleOnOpenAllergenDialog} 
                                            recipe={r} 
                                            key={r.recipe_id} 
                                        />
                                    </div>
                                )
                                    
                        }
                    </div>      
                </div>
            </section>

            <AllergenDialog showDialog={showAllergens} onCancel={toggleAllergens} allergens={allergenDialogContent}  />
        </div>
    )
}